import React from 'react';
import { FormattedMessage } from 'react-intl';

import { isApplePrivateRelayEmail } from 'app/shared/utils/isApplePrivateRelayEmail';
import { PRIVATE_RELAY_HELP_URL } from 'app/shared/utils/siteUrls';
import { User } from 'app/shared/typings';
import { NavigationLink, Typography } from 'app/shared/components/atoms';

export const AccountCreatedSuccess = ({
  user,
  isAppleAuth = false,
}: {
  user: User;
  isAppleAuth?: boolean;
}) => {
  if (isAppleAuth && isApplePrivateRelayEmail(user.email)) {
    return (
      <FormattedMessage
        id="authentication.thirdPartyAuthSuccessAppleRelay"
        values={{
          a: (chunks) => (
            <NavigationLink
              openInNewTab
              messageType="success"
              href={PRIVATE_RELAY_HELP_URL}
              fontSize="fontSize75"
              data-qaid="auth-success-apple-private-relay-link"
            >
              {chunks}
            </NavigationLink>
          ),
        }}
      />
    );
  }

  return (
    <FormattedMessage
      id="authentication.thirdPartyAuthSuccess"
      values={{
        email: user.email,
        a: (chunks) => (
          <NavigationLink
            openInNewTab
            messageType="success"
            href="/profile/edit"
            fontSize="fontSize75"
            data-qaid="auth-success-edit-profile-link"
          >
            {chunks}
          </NavigationLink>
        ),
        b: (chunks) => (
          <Typography
            as="span"
            display="inline"
            fontWeight="bold"
            fontSize="fontSize75"
            color="inherit"
          >
            {chunks}
          </Typography>
        ),
      }}
    />
  );
};
